/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
export interface PasswordInitializeRequest {
  email: string;
}

export interface PasswordResetRequest {
  email: string;
}

export interface PasswordValidateRequest {
  token: string;
  /** @minLength 8 */
  mdp: string;
}

export interface ArbitrageAcceptRequest {
  /**
   * Null si on n'a pas encore vérifié l'identité Universign.
   * @exclusiveMinimum 0
   * @nullable
   */
  subscriptionId?: number | null;
}

export interface ArbitrageAvenantRequest {
  /** Code du support réinvesti */
  codeSupport: string;
  /** Référence de l'avenant */
  reference: string;
}

export interface ArbitrageRefuseRequest {
  placementId: string;
}

export interface AdvisorConnectRequest {
  advisorToken: string;
}

export interface Auth0ChangePasswordRequest {
  /** @maxLength 255 */
  identifiant?: string;
  /** @maxLength 255 */
  motDePasse?: string;
}

export type Auth0CreateRequestCivilite = (typeof Auth0CreateRequestCivilite)[keyof typeof Auth0CreateRequestCivilite];

export const Auth0CreateRequestCivilite = {
  Monsieur: 'Monsieur',
  Madame: 'Madame',
} as const;

export interface Auth0CreateRequest {
  /** @maxLength 255 */
  identifiant?: string;
  /** @maxLength 255 */
  motDePasse?: string;
  civilite?: Auth0CreateRequestCivilite;
  /** @maxLength 100 */
  prenom?: string;
  /** @maxLength 100 */
  nom?: string;
  /**
   * @maxLength 20
   * @nullable
   * @pattern \+?[0-9 ]+
   */
  mobile?: string | null;
}

export interface Auth0CredentialsRequest {
  identifiant?: string;
  motDePasse?: string;
}

export interface Auth0GetUserRequest {
  /** @maxLength 255 */
  identifiant?: string;
}

export interface DigiplaceCancelableRequest {
  /** @maxLength 255 */
  nom: string;
  /** @maxLength 255 */
  prenom: string;
  /** @maxLength 255 */
  placement: string;
  email: string;
  /**
   * @maxLength 255
   * @nullable
   */
  ficheSf?: string | null;
}

/**
 * Paramètres de vérification d'identité d'un signataire Universign
 */
export interface UniversignCheckSignerIdentityRequest {
  /** Numéro de contrat Spirica concerné */
  numContrat: string;
}

/**
 * Paramètres de sauvegarde des fichiers justificatifs d'une souscription
 */
export interface UniversignSauvegardeFileRequest {
  /**
   * ID de la souscription
   * @exclusiveMinimum 0
   */
  idSouscription: number;
  /**
   * Type de document d'identité (cni, passeport, carte-de-sejour)
   * @nullable
   */
  typeDocumentIdentite?: string | null;
  /**
   * Contenu du recto encodé en Base64
   * @nullable
   */
  'justificatif-identite-1-recto'?: string | null;
  /**
   * Contenu du verso encodé en Base64 (non requis pour un passeport)
   * @nullable
   */
  'justificatif-identite-1-verso'?: string | null;
  /**
   * Contenu de la facture téléphonique encodée en Base64
   * @nullable
   */
  'justificatif-telephone'?: string | null;
}

/**
 * Parcours d'origine de la demande, utilisé par SEL pour l'envoi du code par email
 * @nullable
 */
export type UniversignValidationCoordonneesRequestSource =
  | (typeof UniversignValidationCoordonneesRequestSource)[keyof typeof UniversignValidationCoordonneesRequestSource]
  | null;

export const UniversignValidationCoordonneesRequestSource = {
  arbitrage: 'arbitrage',
  versement: 'versement',
} as const;

/**
 * Paramètres de validation des coordonnées d'une souscription
 */
export interface UniversignValidationCoordonneesRequest {
  /**
   * ID de la souscription
   * @exclusiveMinimum 0
   */
  idSouscription: number;
  /**
   * Email à vérifier. Prioritaire sur le téléphone : déclenche l'envoi d'un code.
   * @nullable
   */
  email?: string | null;
  /**
   * Téléphone mobile à enregistrer comme numéro Universign (utilisé si l'email est vide)
   * @nullable
   */
  telephone?: string | null;
  /**
   * Parcours d'origine de la demande, utilisé par SEL pour l'envoi du code par email
   * @nullable
   */
  source?: UniversignValidationCoordonneesRequestSource;
}

/**
 * Paramètres de validation du code de vérification d'une souscription
 */
export interface UniversignValidationTokenRequest {
  /**
   * ID de la souscription
   * @exclusiveMinimum 0
   */
  idSouscription: number;
  /** Code de vérification reçu par email */
  code: string;
}

/**
 * Response for KYC status query
 */
export interface KycStatusResponse {
  /** Operation success status */
  success: boolean;
  /**
   * KYC status: OK if validated, KO otherwise
   * @nullable
   */
  statutKyc?: string | null;
}

/**
 * User profile data
 */
export interface ProfileResponse {
  /** Operation success status */
  success: boolean;
  /**
   * Salesforce contact identifier
   * @nullable
   */
  id?: string | null;
  /**
   * JWT authentication token
   * @nullable
   */
  token?: string | null;
  /**
   * Last name
   * @nullable
   */
  nom?: string | null;
  /**
   * First name
   * @nullable
   */
  prenom?: string | null;
  /**
   * Email address
   * @nullable
   */
  email?: string | null;
  /**
   * Phone number
   * @nullable
   */
  telephone?: string | null;
  /**
   * Street address
   * @nullable
   */
  adresse?: string | null;
  /**
   * Postal code
   * @nullable
   */
  codePostal?: string | null;
  /**
   * City
   * @nullable
   */
  ville?: string | null;
  /**
   * Legal capacity
   * @nullable
   */
  capaciteJuridique?: string | null;
  /**
   * Contact type (Client or Prospect)
   * @nullable
   */
  type?: string | null;
  /**
   * Date of birth (format: YYYY-MM-DD)
   * @nullable
   */
  birthDate?: string | null;
}

export interface DocumentResponse {
  success: boolean;
  /** @nullable */
  typeDocument?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  extension?: string | null;
  /** @nullable */
  createdDate?: string | null;
  /** @nullable */
  contentType?: string | null;
  /** @nullable */
  body?: string | null;
}

export interface QpsReponse {
  id: string;
  value: string;
  reponse: string;
  bonneReponse: boolean;
  /** @nullable */
  name?: string | null;
}

export interface QpsReference {
  questionnaire: string;
  version: string;
  /** @nullable */
  rubrique?: string | null;
  /** @nullable */
  question?: string | null;
}

export interface QpsRenvoi {
  numero: number;
  contenu: string;
}

export interface QpsQuestion {
  id: string;
  question: string;
  type: string;
  reponses: QpsReponse[];
  qps: QpsReference;
  /** @nullable */
  conseil?: string | null;
  renvois?: QpsRenvoi[];
}

export interface QpsQuestionnaireInfos {
  /** @nullable */
  libelle?: string | null;
  /** @nullable */
  description?: string | null;
}

export interface QpsAvenant {
  reference: string;
  url: string;
}

export interface ArbitrageInvestissableItem {
  /** @nullable */
  pourcentage?: number | null;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  codeSupport?: string | null;
  /** @nullable */
  typeSupport?: string | null;
  /** @nullable */
  montantNetAInvestir?: number | null;
  /** @nullable */
  fraisEntree?: number | null;
  /** @nullable */
  srri?: number | null;
  /** @nullable */
  perfYTD?: number | null;
  /** @nullable */
  perf12M?: number | null;
  /** @nullable */
  perf36M?: number | null;
  /** @nullable */
  perf60M?: number | null;
  /** @nullable */
  codeIsin?: string | null;
  /** @nullable */
  sousTypeFonds?: string | null;
  /** @nullable */
  gestionnaire?: string | null;
  /** @nullable */
  questionnaire?: QpsQuestion[] | null;
  questionnaireInfos?: QpsQuestionnaireInfos | null;
  /** @nullable */
  avenants?: QpsAvenant[] | null;
}

export interface ArbitrageDesinvestissableItem {
  /** @nullable */
  pourcentage?: number | null;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  codeSupport?: string | null;
  /** @nullable */
  typeSupport?: string | null;
  /** @nullable */
  montantNetDetenu?: number | null;
  /** @nullable */
  montantDesinvesti?: number | null;
  /** @nullable */
  fraisSortie?: number | null;
  /** @nullable */
  srri?: number | null;
  /** @nullable */
  perfYTD?: number | null;
  /** @nullable */
  perf12M?: number | null;
  /** @nullable */
  perf36M?: number | null;
  /** @nullable */
  perf60M?: number | null;
  /** @nullable */
  codeIsin?: string | null;
  /** @nullable */
  sousTypeFonds?: string | null;
  /** @nullable */
  gestionnaire?: string | null;
}

export interface ArbitrageSupports {
  supportsInvestis?: ArbitrageInvestissableItem[];
  supportsDesinvestis?: ArbitrageDesinvestissableItem[];
  /** @nullable */
  currentSrri?: number | null;
  /** @nullable */
  currentInvestProfil?: string | null;
  /** @nullable */
  newSrri?: number | null;
  /** @nullable */
  newInvestProfil?: string | null;
}

export interface SupportCategoryItem {
  /** @nullable */
  name?: string | null;
  montantTotal: number;
  pourcentTotal: number;
  couleur: string;
}

export interface ArbitrageDetailItem {
  /** @nullable */
  arbitrageId?: string | null;
  /** @nullable */
  placementId?: string | null;
  /** @nullable */
  contactId?: string | null;
  /** @nullable */
  accountId?: string | null;
  /** @nullable */
  numContrat?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  profilChoisi?: string | null;
  /** @nullable */
  closeDate?: string | null;
  supports?: ArbitrageSupports | null;
  /** @nullable */
  actualAllocation?: SupportCategoryItem[] | null;
  /** @nullable */
  newAllocation?: SupportCategoryItem[] | null;
}

export interface AdvisorConnectResponse {
  success: boolean;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  nom?: string | null;
  /** @nullable */
  prenom?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  telephone?: string | null;
  /** @nullable */
  adresse?: string | null;
  /** @nullable */
  codePostal?: string | null;
  /** @nullable */
  ville?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  advisorView?: boolean | null;
  /** @nullable */
  token?: string | null;
  /** @nullable */
  dateTokenCreation?: string | null;
}

export interface Auth0CredentialsResponse {
  user_id: string;
  email: string;
  email_verified?: boolean;
}

export interface CarrouselItem {
  /** @nullable */
  imageDesktop?: string | null;
  /** @nullable */
  imageMobile?: string | null;
  /** @nullable */
  imageAlt?: string | null;
  /** @nullable */
  lien?: string | null;
  /** @nullable */
  titre?: string | null;
  /** @nullable */
  sousTitre?: string | null;
  /** @nullable */
  mentions?: string | null;
  /** @nullable */
  tracking?: string | null;
  /** @nullable */
  dateDebut?: string | null;
  /** @nullable */
  dateFin?: string | null;
}

export interface CarrouselResponse {
  valide: boolean;
  carrousel: CarrouselItem[];
  env: string;
}

export interface ValorizationData {
  /** @nullable */
  encours?: number | null;
  /** @nullable */
  dateEncours?: string | null;
}

export interface EvolutionData {
  /** @nullable */
  performance?: number | null;
  /** @nullable */
  plusMoinsValue?: number | null;
}

export interface ChartEvolutionPeriodData {
  /** @nullable */
  plusMoinsValueYTD?: number | null;
  /** @nullable */
  plusMoinsValue1Y?: number | null;
  /** @nullable */
  plusMoinsValue1W?: number | null;
  /** @nullable */
  plusMoinsValue1M?: number | null;
  /** @nullable */
  performanceYTD?: number | null;
  /** @nullable */
  performance1Y?: number | null;
  /** @nullable */
  performance1W?: number | null;
  /** @nullable */
  performance1M?: number | null;
}

export interface ChartDataPoint {
  /** @nullable */
  d?: string | null;
  /** @nullable */
  m?: number | null;
}

export interface ChartResponse {
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  evolutionPeriode?: ChartEvolutionPeriodData | null;
  /** @nullable */
  chartData?: ChartDataPoint[] | null;
}

export interface EvolutionPeriodData {
  /** @nullable */
  key?: string | null;
  /** @nullable */
  performance?: number | null;
  /** @nullable */
  plusMoinsValue?: number | null;
}

export interface DistributionRateData {
  /** @nullable */
  pourcentage?: number | null;
  /** @nullable */
  anneeRef?: number | null;
}

export interface InterestsData {
  /** @nullable */
  interetsNet?: number | null;
  /** @nullable */
  interetsBrut?: number | null;
}

export interface CategoryPlacementItem {
  /** @nullable */
  placementId?: string | null;
  /** @nullable */
  objectif?: string | null;
  /** @nullable */
  nomProduit?: string | null;
  evolution?: EvolutionData | null;
  valorisation?: ValorizationData | null;
  /** @nullable */
  vlpActif?: boolean | null;
  /** @nullable */
  gestionnaire?: string | null;
  /** @nullable */
  gestionnaireLogo?: string | null;
  /** @nullable */
  gestionnaireAC?: string | null;
  /** @nullable */
  statut?: string | null;
  /** @nullable */
  cancelablePeriod?: number | null;
  /** @nullable */
  isCancelable?: boolean | null;
  tauxDistribution?: DistributionRateData | null;
  interetsAVenir?: InterestsData | null;
}

export interface EnTraitementItem {
  /** @nullable */
  famille?: string | null;
  /** @nullable */
  nomProduit?: string | null;
  /** @nullable */
  slugProduit?: string | null;
  /** @nullable */
  mpId?: number | null;
  /** @nullable */
  idGestionnaire?: string | null;
  /** @nullable */
  gestionnaire?: string | null;
}

export interface PlacementsContainer {
  /** @nullable */
  enCours?: CategoryPlacementItem[] | null;
  /** @nullable */
  enTraitement?: EnTraitementItem[] | null;
}

export interface DocumentItem {
  token: string;
  typeDocument: string;
  dateDocument: string;
  millesime: string;
}

export interface CategoryDashboardResponse {
  success: boolean;
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  /** @nullable */
  evolutionPeriode?: EvolutionPeriodData[] | null;
  /** @nullable */
  chartData?: ChartDataPoint[] | null;
  placements?: PlacementsContainer | null;
  interetsAVenir?: InterestsData | null;
  /** @nullable */
  documents?: DocumentItem[] | null;
}

export interface ContractItem {
  /** @nullable */
  placementId?: string | null;
  /** @nullable */
  famille?: string | null;
  /** @nullable */
  nomProduit?: string | null;
  /** @nullable */
  idGestionnaire?: string | null;
  /** @nullable */
  gestionnaire?: string | null;
  /** @nullable */
  gestionnaireLogo?: string | null;
  /** @nullable */
  gestionnaireAC?: string | null;
  /** @nullable */
  dateOuverture?: string | null;
  /** @nullable */
  statut?: string | null;
  /** @nullable */
  cancelablePeriod?: number | null;
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  /** @nullable */
  vlpActif?: boolean | null;
  /** @nullable */
  isCancelable?: boolean | null;
  interetsAVenir?: InterestsData | null;
  tauxDistribution?: DistributionRateData | null;
}

export interface ContractListContainer {
  /** @nullable */
  enCours?: ContractItem[] | null;
  /** @nullable */
  enTraitement?: ContractItem[] | null;
}

export interface FamilyContractsContainer {
  /** @nullable */
  famille?: string | null;
  listContrat?: ContractListContainer | null;
}

export interface ContractsDashboardResponse {
  success: boolean;
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  /** @nullable */
  evolutionPeriode?: EvolutionPeriodData[] | null;
  /** @nullable */
  chartData?: ChartDataPoint[] | null;
  /** @nullable */
  families?: FamilyContractsContainer[] | null;
}

export interface AFinalizerItem {
  /** @nullable */
  famille?: string | null;
  /** @nullable */
  dateDebutSouscription?: string | null;
  /** @nullable */
  nomProduit?: string | null;
  /** @nullable */
  pourcentageAvancement?: number | null;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  headerName?: string | null;
  /** @nullable */
  token?: string | null;
  /** @nullable */
  etape?: string | null;
}

export interface EnCoursItemBase {
  /** @nullable */
  famille?: string | null;
  /** @nullable */
  nombrePlacement?: number | null;
  /** @nullable */
  placementId?: string | null;
}

export interface DashboardResponse {
  success: boolean;
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  /** @nullable */
  evolutionPeriode?: EvolutionPeriodData[] | null;
  /** @nullable */
  chartData?: ChartDataPoint[] | null;
  /** @nullable */
  aFinaliser?: AFinalizerItem[] | null;
  /** @nullable */
  enCours?: EnCoursItemBase[] | null;
  /** @nullable */
  enTraitement?: EnTraitementItem[] | null;
}

export interface EvolutionDashboardResponse {
  success: boolean;
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  /** @nullable */
  evolutionPeriode?: EvolutionPeriodData[] | null;
  /** @nullable */
  chartData?: ChartDataPoint[] | null;
  listContrat?: ContractListContainer | null;
  /** @nullable */
  aFinaliser?: AFinalizerItem[] | null;
}

export interface VolumetrieData {
  assurancevie: number;
  retraite: number;
  defiscalisation: number;
  immobilier: number;
  livret: number;
  bourse: number;
}

export interface ContractsListingResponse {
  success: boolean;
  /** @nullable */
  listContrat?: ContractItem[] | null;
  volumetrie?: VolumetrieData | null;
}

export interface ContractsCountResponse {
  ASSURANCEVIE: number;
  RETRAITE: number;
  DEFISCALISATION: number;
  IMMOBILIER: number;
  BOURSE: number;
  LIVRET: number;
}

export interface DigiplaceCancelableResponse {
  success: boolean;
  /** @nullable */
  message?: string | null;
}

/**
 * Niveau d'importance de la notification
 * @nullable
 */
export type NotificationItemDTOStatus =
  (typeof NotificationItemDTOStatus)[keyof typeof NotificationItemDTOStatus] | null;

export const NotificationItemDTOStatus = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  URGENT: 'URGENT',
} as const;

/**
 * Catégorie de la notification
 * @nullable
 */
export type NotificationItemDTOCategory =
  (typeof NotificationItemDTOCategory)[keyof typeof NotificationItemDTOCategory] | null;

export const NotificationItemDTOCategory = {
  GENERAL_INFORMATIONS: 'GENERAL_INFORMATIONS',
  OFFERS: 'OFFERS',
  MY_OPERATIONS: 'MY_OPERATIONS',
} as const;

export interface NotificationItemDTO {
  id: string;
  title: string;
  message: string;
  creationDate: string;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  linkLabel?: string | null;
  /** @nullable */
  mobileLink?: string | null;
  openInNewTab?: boolean;
  /**
   * Niveau d'importance de la notification
   * @nullable
   */
  status?: NotificationItemDTOStatus;
  /** @nullable */
  imageUrl?: string | null;
  /**
   * Catégorie de la notification
   * @nullable
   */
  category?: NotificationItemDTOCategory;
}

export interface NotificationsResponse {
  notifications: NotificationItemDTO[];
}

/**
 * Issue de l'opération : `error` (aucun retour partenaire / timeout), `success` (opération acceptée) ou `fail` (opération refusée)
 */
export type RetourPartenaireResponseReturn =
  (typeof RetourPartenaireResponseReturn)[keyof typeof RetourPartenaireResponseReturn];

export const RetourPartenaireResponseReturn = {
  error: 'error',
  success: 'success',
  fail: 'fail',
} as const;

/**
 * Résultat du standby de fin de tunnel (retour partenaire)
 */
export interface RetourPartenaireResponse {
  /** true si la souscription liée au token a été trouvée, false sinon */
  valide: boolean;
  /** Issue de l'opération : `error` (aucun retour partenaire / timeout), `success` (opération acceptée) ou `fail` (opération refusée) */
  return: RetourPartenaireResponseReturn;
  /**
   * Identifiant Salesforce du placement concerné. Présent uniquement si valide = true.
   * @nullable
   */
  placement?: string | null;
}

export interface SupportItem {
  /** @nullable */
  supportId?: string | null;
  /** @nullable */
  nomSupport?: string | null;
  /** @nullable */
  isin?: string | null;
  /** @nullable */
  allocation?: number | null;
  /** @nullable */
  poids?: number | null;
  /** @nullable */
  libelleCategorieSupport?: string | null;
  /** @nullable */
  categorieSupportSlug?: string | null;
  /** @nullable */
  modeGestion?: string | null;
  /** @nullable */
  modeGestionLibelle?: string | null;
  /** @nullable */
  pmvPct?: number | null;
  /** @nullable */
  pmvEuro?: number | null;
  /** @nullable */
  cotation?: number | null;
  /** @nullable */
  dateCotation?: string | null;
  /** @nullable */
  prm?: number | null;
  /** @nullable */
  nbParts?: number | null;
  /** @nullable */
  pourcentCategorie?: number | null;
  /** @nullable */
  srri?: number | null;
  /** @nullable */
  typeProfil?: string | null;
}

export interface OperationItem {
  /** @nullable */
  typeOperation?: string | null;
  /** @nullable */
  dateOperation?: string | null;
  montantOperation?: number | null;
  /** @nullable */
  mode?: string | null;
}

export interface VersementResult {
  valid: boolean;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  headerName?: string | null;
  /** @nullable */
  token?: string | null;
  /** @nullable */
  codeErreur?: string | null;
  /** @nullable */
  titre?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  eligibleDeductionFiscale?: boolean | null;
}

export interface PlacementDocumentItem {
  /** @nullable */
  token?: string | null;
  /** @nullable */
  typeDocument?: string | null;
  /** @nullable */
  dateDocument?: string | null;
  /** @nullable */
  millesime?: string | null;
}

export interface PlacementAssuranceVieResponse {
  succes: boolean;
  /** @nullable */
  placementId?: string | null;
  /** @nullable */
  nomProduit?: string | null;
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  /** @nullable */
  evolutionPeriode?: EvolutionPeriodData[] | null;
  /** @nullable */
  chartData?: ChartDataPoint[] | null;
  /** @nullable */
  gestionnaire?: string | null;
  /** @nullable */
  gestionnaireLogo?: string | null;
  /** @nullable */
  gestionnaireAC?: string | null;
  /** @nullable */
  objectifPlacement?: string | null;
  /** @nullable */
  numContrat?: string | null;
  /** @nullable */
  dateOuverture?: string | null;
  /** @nullable */
  horizonPlacement?: string | null;
  /** @nullable */
  modeGestion?: string | null;
  /** @nullable */
  cancelablePeriod?: number | null;
  /** @nullable */
  versementInitial?: number | null;
  /** @nullable */
  versementProgramme?: number | null;
  /** @nullable */
  versementProgrammePeriodicite?: string | null;
  /** @nullable */
  montantTotalVerse?: number | null;
  /** @nullable */
  montantTotalRachete?: number | null;
  /** @nullable */
  top5Supports?: SupportItem[] | null;
  /** @nullable */
  dernieresOperations?: OperationItem[] | null;
  versement?: VersementResult | null;
  /** @nullable */
  documents?: PlacementDocumentItem[] | null;
  /** @nullable */
  famille?: string | null;
  /** @nullable */
  isCancelable?: boolean | null;
}

export interface PlacementDefiscalisationResponse {
  succes: boolean;
  /** @nullable */
  placementId?: string | null;
  /** @nullable */
  nomProduit?: string | null;
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  evolutionAF?: EvolutionData | null;
  /** @nullable */
  evolutionPeriode?: EvolutionPeriodData[] | null;
  /** @nullable */
  evolutionAFPeriode?: EvolutionPeriodData[] | null;
  /** @nullable */
  chartData?: ChartDataPoint[] | null;
  /** @nullable */
  gestionnaire?: string | null;
  /** @nullable */
  gestionnaireAC?: string | null;
  /** @nullable */
  statut?: string | null;
  /** @nullable */
  categorie?: string | null;
  /** @nullable */
  cancelablePeriod?: number | null;
  /** @nullable */
  annee?: string | null;
  /** @nullable */
  versementInitial?: number | null;
  /** @nullable */
  reducImpotPourcent?: number | null;
  /** @nullable */
  blocageMin?: string | null;
  /** @nullable */
  blocageMax?: string | null;
  /** @nullable */
  plaquetteProduit?: string | null;
  /** @nullable */
  rapportGestion?: string | null;
  /** @nullable */
  documents?: PlacementDocumentItem[] | null;
  /** @nullable */
  famille?: string | null;
  /** @nullable */
  isCancelable?: boolean | null;
}

export interface PlacementDetailsResponse {
  succes: boolean;
  /** @nullable */
  categories?: SupportCategoryItem[] | null;
  /** @nullable */
  supports?: SupportItem[] | null;
}

export interface TriItem {
  /** @nullable */
  nbAnnees?: number | null;
  /** @nullable */
  pourcentage?: number | null;
}

export interface TauxDistributionItem {
  /** @nullable */
  pourcentage?: number | null;
  /** @nullable */
  anneeRef?: number | null;
}

export interface EvoPrixReventeItem {
  /** @nullable */
  dateVL?: string | null;
  /** @nullable */
  valorisation?: number | null;
}

export interface PlacementImmobilierResponse {
  succes: boolean;
  /** @nullable */
  placementId?: string | null;
  /** @nullable */
  nomProduit?: string | null;
  valorisation?: ValorizationData | null;
  /** @nullable */
  gestionnaire?: string | null;
  /** @nullable */
  gestionnaireAC?: string | null;
  /** @nullable */
  dateSouscription?: string | null;
  /** @nullable */
  horizonPlacement?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  modeAquisition?: string | null;
  /** @nullable */
  typePropriete?: string | null;
  /** @nullable */
  cancelablePeriod?: number | null;
  /** @nullable */
  nombrePart?: number | null;
  /** @nullable */
  valeurOrigine?: number | null;
  /** @nullable */
  valeurRetrait?: number | null;
  /** @nullable */
  versementInitial?: number | null;
  /** @nullable */
  plaquetteProduit?: string | null;
  /** @nullable */
  rapportGestion?: string | null;
  /** @nullable */
  TRI?: TriItem[] | null;
  /** @nullable */
  tauxDistribution?: TauxDistributionItem[] | null;
  /** @nullable */
  evoPrixRevente?: EvoPrixReventeItem[] | null;
  /** @nullable */
  documents?: PlacementDocumentItem[] | null;
  /** @nullable */
  famille?: string | null;
  /** @nullable */
  typeCapital?: string | null;
  /** @nullable */
  isCancelable?: boolean | null;
}

export interface PlacementLivretResponse {
  succes: boolean;
  /** @nullable */
  placementId?: string | null;
  /** @nullable */
  nomProduit?: string | null;
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  interetsAVenir?: InterestsData | null;
  /** @nullable */
  evolutionPeriode?: EvolutionPeriodData[] | null;
  /** @nullable */
  chartData?: ChartDataPoint[] | null;
  /** @nullable */
  gestionnaire?: string | null;
  /** @nullable */
  gestionnaireLogo?: string | null;
  /** @nullable */
  cancelablePeriod?: number | null;
  /** @nullable */
  gestionnaireAC?: string | null;
  /** @nullable */
  numContrat?: string | null;
  /** @nullable */
  dateOuverture?: string | null;
  /** @nullable */
  tauxInteretStandard?: number | null;
  /** @nullable */
  tauxInteretBooste?: number | null;
  /** @nullable */
  versementInitial?: number | null;
  /** @nullable */
  montantTotalVerse?: number | null;
  /** @nullable */
  montantTotalRetire?: number | null;
  /** @nullable */
  dernieresOperations?: OperationItem[] | null;
  /** @nullable */
  famille?: string | null;
  /** @nullable */
  isCancelable?: boolean | null;
}

export interface PlacementOperationsResponse {
  succes: boolean;
  /** @nullable */
  operations?: OperationItem[] | null;
}

export interface PlacementRetraiteResponse {
  succes: boolean;
  /** @nullable */
  placementId?: string | null;
  /** @nullable */
  nomProduit?: string | null;
  valorisation?: ValorizationData | null;
  evolution?: EvolutionData | null;
  /** @nullable */
  evolutionPeriode?: EvolutionPeriodData[] | null;
  /** @nullable */
  chartData?: ChartDataPoint[] | null;
  /** @nullable */
  gestionnaire?: string | null;
  /** @nullable */
  gestionnaireLogo?: string | null;
  /** @nullable */
  gestionnaireAC?: string | null;
  /** @nullable */
  objectifPlacement?: string | null;
  /** @nullable */
  numContrat?: string | null;
  /** @nullable */
  cancelablePeriod?: number | null;
  /** @nullable */
  dateOuverture?: string | null;
  /** @nullable */
  horizonPlacement?: string | null;
  /** @nullable */
  modeGestion?: string | null;
  /** @nullable */
  versementInitial?: number | null;
  /** @nullable */
  versementProgramme?: number | null;
  /** @nullable */
  versementProgrammePeriodicite?: string | null;
  /** @nullable */
  montantTotalVerse?: number | null;
  /** @nullable */
  montantTotalRachete?: number | null;
  /** @nullable */
  top5Supports?: SupportItem[] | null;
  /** @nullable */
  dernieresOperations?: OperationItem[] | null;
  versement?: VersementResult | null;
  /** @nullable */
  documents?: PlacementDocumentItem[] | null;
  /** @nullable */
  famille?: string | null;
  /** @nullable */
  isCancelable?: boolean | null;
}

/**
 * Résultat de la vérification d'identité d'un signataire Universign
 */
export interface UniversignCheckSignerIdentityResponse {
  /** true si l'identité est certifiée dans Universign, false dans le cas contraire */
  identityKnown: boolean;
  /**
   * ID de la souscription créée côté SEL pour stocker les documents d'identité. Présent uniquement si identityKnown = false.
   * @nullable
   */
  idSouscription?: number | null;
}

/**
 * Résultat de la sauvegarde de fichiers justificatifs
 */
export interface UniversignSauvegardeFileResponse {
  /** Indique si la sauvegarde a réussi */
  success: boolean;
  /** Non sérialisé dans la réponse JSON (usage interne controller uniquement). */
  httpStatusCode: number;
  /**
   * ID de la souscription mise à jour
   * @nullable
   */
  idSouscription?: number | null;
  /**
   * Aperçu (base64 JPEG) du dernier fichier sauvegardé, avec filigrane
   * @nullable
   */
  preview?: string | null;
  /**
   * Message d'erreur en cas d'échec
   * @nullable
   */
  message?: string | null;
}

/**
 * Résultat de la validation des coordonnées d'une souscription
 */
export interface UniversignValidationCoordonneesResponse {
  /** Non sérialisé dans la réponse JSON (usage interne controller uniquement). */
  httpStatusCode: number;
  /**
   * Indique si le traitement SEL s'est déroulé sans erreur
   * @nullable
   */
  success?: boolean | null;
  /**
   * Indique si les coordonnées sont exploitables (false si déjà utilisées)
   * @nullable
   */
  valide?: boolean | null;
  /**
   * true si un code de vérification vient d'être envoyé par email
   * @nullable
   */
  emailToCheck?: boolean | null;
  /**
   * Message d'erreur ou d'information renvoyé par SEL
   * @nullable
   */
  message?: string | null;
}

/**
 * Résultat de la validation du code de vérification d'une souscription
 */
export interface UniversignValidationTokenResponse {
  /** Non sérialisé dans la réponse JSON (usage interne controller uniquement). */
  httpStatusCode: number;
  /**
   * Indique si le traitement SEL s'est déroulé sans erreur
   * @nullable
   */
  success?: boolean | null;
  /**
   * true si le code fourni correspond au code attendu et n'est pas expiré
   * @nullable
   */
  valide?: boolean | null;
  /**
   * Message d'erreur ou d'information renvoyé par SEL
   * @nullable
   */
  message?: string | null;
}

export type UserLoginBody = {
  /** User email address (Salesforce identifier) */
  identifiant: string;
  /** User password */
  motDePasse: string;
  /** Origin of the login request */
  origineDemande?: string;
};

export type UserLogin200 = {
  /** JWT access token */
  token?: string;
  /** Refresh token for obtaining new access tokens */
  refresh_token?: string;
};

export type UserLogin401 = {
  message?: string;
};

/**
 * Environment for sso authentication
 */
export type AdvisorLoginBodyEnvironment =
  (typeof AdvisorLoginBodyEnvironment)[keyof typeof AdvisorLoginBodyEnvironment];

export const AdvisorLoginBodyEnvironment = {
  PREPROD: 'PREPROD',
  PROD: 'PROD',
  DEV: 'DEV',
} as const;

export type AdvisorLoginBody = {
  /** Advisor contact ID in salesforce */
  contactId: string;
  /** User ID in salesforce */
  userId: string;
  /** Type of user ("Client", ...) */
  type: string;
  /** Environment for sso authentication */
  environment?: AdvisorLoginBodyEnvironment;
};

export type AdvisorLogin200 = {
  succes?: boolean;
  /** User ID in Salesforce */
  userId?: string;
  /** JWT access token */
  token?: string;
  /** URL of the client space for the advisor */
  espaceClientUrl?: string;
};

export type AdvisorLogin401 = {
  message?: string;
};

export type RefreshTokenBody = {
  /** The refresh token obtained during login (mobile clients only) */
  refresh_token?: string;
};

export type RefreshToken200 = {
  /** New JWT access token */
  token?: string;
  /** New refresh token (single-use — replaces the previous one) */
  refresh_token?: string;
};

export type RefreshToken401 = {
  code?: number;
  message?: string;
};

export type InvalidateTokenBody = {
  /** The refresh token to invalidate */
  refresh_token: string;
};

export type InvalidateToken200 = {
  message?: string;
};

export type InvalidateToken401 = {
  code?: number;
  message?: string;
};

export type GetApiAccountKycStatus401 = {
  success?: boolean;
};

export type GetApiAccountKycStatus403 = {
  message?: string;
};

export type GetApiAccountKycStatus500 = {
  success?: boolean;
};

export type PostAppAccountPasswordinitializeInvoke200 = {
  succes?: boolean;
};

export type PostAppAccountPasswordinitializeInvoke400 = {
  succes?: boolean;
  error?: string;
};

export type PostAppAccountPasswordresetInvoke200 = {
  succes?: boolean;
};

export type PostAppAccountPasswordresetInvoke400 = {
  succes?: boolean;
  error?: string;
};

export type PostAppAccountPasswordresetInvoke401 = {
  succes?: boolean;
};

export type PostAppAccountPasswordvalidateInvoke200 = {
  succes?: boolean;
};

export type PostAppAccountPasswordvalidateInvoke400 = {
  succes?: boolean;
  error?: string;
};

export type GetApiAccountProfile422 = {
  success?: boolean;
};

export type PostApiArbitrageAcceptBody = {
  /**
   * ID de souscription SEL si le client a déjà uploadé sa pièce d'identité. Absent si le client est déjà connu d'Universign
   * @nullable
   */
  subscriptionId?: number | null;
};

export type PostApiArbitrageAccept200 = {
  url?: string;
};

export type PostApiArbitrageAccept401 = {
  success?: boolean;
};

export type PostApiArbitrageAccept403 = {
  success?: boolean;
};

export type PostApiArbitrageAccept409 = {
  detail?: string;
  /** @nullable */
  idSouscription?: number | null;
  /** @nullable */
  reasons?: string[] | null;
};

export type PostApiArbitrageAccept410 = {
  detail?: string;
};

export type PostApiArbitrageAccept422 = {
  detail?: string;
  /** @nullable */
  error?: string | null;
  /**
   * Motif brut du refus Universign (ex. DOCUMENT_COPY_FAILURE). null si Universign n'a pas statué (erreur technique, coordonnées déjà utilisées).
   * @nullable
   */
  reasonMessage?: string | null;
  /** @nullable */
  pieceLu?: boolean | null;
  /** @nullable */
  infosNonCorrespondante?: boolean | null;
  /** @nullable */
  pieceExpire?: boolean | null;
  /** @nullable */
  pieceMRZ?: boolean | null;
  /** @nullable */
  coordonneesUtilise?: boolean | null;
  /** @nullable */
  emailUtilise?: string | null;
  /** @nullable */
  telephoneUtilise?: string | null;
  /** @nullable */
  birthdate?: string | null;
};

export type PostApiArbitrageAccept502 = {
  detail?: string;
};

export type PostApiArbitrageAccept504 = {
  detail?: string;
};

export type GetApiArbitrageAvenantParams = {
  /**
   * Code du support réinvesti
   */
  codeSupport: string;
  /**
   * Référence de l'avenant
   */
  reference: string;
};

export type GetApiArbitrageDetail401 = {
  success?: boolean;
};

export type GetApiArbitrageDetail403 = {
  success?: boolean;
};

export type GetApiArbitrageDetail409 = {
  detail?: string;
  reasons?: string[];
};

export type GetApiArbitrageDetail410 = {
  detail?: string;
};

export type GetApiArbitrageDetail502 = {
  detail?: string;
};

export type PostApiArbitrageRefuseBody = {
  placementId: string;
};

export type PostApiArbitrageRefuse401 = {
  success?: boolean;
};

export type PostApiArbitrageRefuse403 = {
  success?: boolean;
};

export type PostApiArbitrageRefuse422 = {
  detail?: string;
};

export type PostApiArbitrageRefuse502 = {
  detail?: string;
};

export type GetApiArbitragesParams = {
  /**
   * Filtre les arbitrages par identifiant de placement
   */
  idPlacement?: string;
};

export type GetApiArbitrages200Item = {
  /** @nullable */
  arbitrageId?: string | null;
  /** @nullable */
  idPlacement?: string | null;
  /** @nullable */
  contractName?: string | null;
};

export type GetApiArbitrages401 = {
  success?: boolean;
};

export type GetApiArbitrages403 = {
  success?: boolean;
};

export type GetApiArbitrages502 = {
  detail?: string;
};

export type PostAppAuthenticationAdvisorconnectInvoke401 = {
  succes?: boolean;
};

export type GetApiCarrousel401 = {
  success?: boolean;
};

export type GetApiCarrousel403 = {
  success?: boolean;
};

export type GetApiDashboardByCategory401 = {
  success?: boolean;
};

export type GetApiDashboardByCategory403 = {
  success?: boolean;
};

export type GetApiDashboardContrats401 = {
  success?: boolean;
};

export type GetApiDashboardContrats403 = {
  success?: boolean;
};

export type GetApiDashboard401 = {
  success?: boolean;
};

export type GetApiDashboard403 = {
  success?: boolean;
};

export type GetApiDashboardEvo401 = {
  success?: boolean;
};

export type GetApiDashboardEvo403 = {
  success?: boolean;
};

export type GetApiDashboardListingContrats401 = {
  success?: boolean;
};

export type GetApiDashboardListingContrats403 = {
  success?: boolean;
};

export type GetApiDashboardListingContratsCount401 = {
  success?: boolean;
};

export type GetApiDashboardListingContratsCount403 = {
  success?: boolean;
};

export type PostAppDigiplaceDigiplacecancelableInvoke400 = {
  success?: boolean;
};

export type PostAppDigiplaceDigiplacecancelableInvoke401 = {
  message?: string;
};

export type PostAppDigiplaceDigiplacecancelableInvoke502 = {
  success?: boolean;
  message?: string;
};

export type GetApiDocument400 = {
  success?: boolean;
};

export type GetApiDocument403 = {
  success?: boolean;
};

export type GetAppPing200 = {
  success?: boolean;
};

export type GetAppPing401 = {
  success?: boolean;
};

export type GetApiNotification401 = {
  success?: boolean;
};

export type GetApiNotification403 = {
  success?: boolean;
};

export type GetApiNotification404 = {
  detail?: string;
};

export type GetApiNotifications401 = {
  success?: boolean;
};

export type GetApiNotifications403 = {
  success?: boolean;
};

export type PostApiStandbyFinTunnel401 = {
  success?: boolean;
};

export type PostApiStandbyFinTunnel403 = {
  success?: boolean;
};

export type PostApiStandbyFinTunnel502 = {
  error?: string;
  detail?: string;
};

export type GetApiPlacementAssuranceVie400 = {
  success?: boolean;
};

export type GetApiPlacementAssuranceVie403 = {
  success?: boolean;
};

export type GetApiPlacementDefiscalisation400 = {
  success?: boolean;
};

export type GetApiPlacementDefiscalisation403 = {
  success?: boolean;
};

export type GetApiPlacementDetails403 = {
  success?: boolean;
};

export type GetApiPlacementEligible403 = {
  success?: boolean;
};

export type GetApiPlacementImmobilier400 = {
  success?: boolean;
};

export type GetApiPlacementImmobilier403 = {
  success?: boolean;
};

export type GetApiPlacementLivret400 = {
  success?: boolean;
};

export type GetApiPlacementLivret403 = {
  success?: boolean;
};

export type GetApiPlacementOperations403 = {
  success?: boolean;
};

export type GetApiPlacementRetraite400 = {
  success?: boolean;
};

export type GetApiPlacementRetraite403 = {
  success?: boolean;
};

export type PostApiUniversignCheckSignerIdentity422 = {
  detail?: string;
};

export type PostApiUniversignCheckSignerIdentity502 = {
  error?: string;
  detail?: string;
};

export type PostApiUniversignCheckSignerIdentity504 = {
  error?: string;
  detail?: string;
};

export type PostApiUniversignSauvegardeFichier401 = {
  success?: boolean;
  message?: string;
};

export type PostApiUniversignSauvegardeFichier404 = {
  success?: boolean;
  message?: string;
};

export type PostApiUniversignSauvegardeFichier422 = {
  detail?: string;
};

export type PostApiUniversignSauvegardeFichier502 = {
  error?: string;
  detail?: string;
};

export type PostApiUniversignValidationCoordonnees401 = {
  success?: boolean;
  message?: string;
};

export type PostApiUniversignValidationCoordonnees404 = {
  success?: boolean;
  message?: string;
};

export type PostApiUniversignValidationCoordonnees422 = {
  detail?: string;
};

export type PostApiUniversignValidationCoordonnees502 = {
  error?: string;
  detail?: string;
};

export type PostApiUniversignValidationToken401 = {
  success?: boolean;
  message?: string;
};

export type PostApiUniversignValidationToken404 = {
  success?: boolean;
  message?: string;
};

export type PostApiUniversignValidationToken422 = {
  detail?: string;
};

export type PostApiUniversignValidationToken502 = {
  error?: string;
  detail?: string;
};
